export const formatTelemetryAge = (ageSeconds) => {
  if (ageSeconds === undefined || ageSeconds === null) return "—";
  if (ageSeconds < 60) return `${ageSeconds} sn`;
  if (ageSeconds < 3600) return `${Math.floor(ageSeconds / 60)} dk`;
  if (ageSeconds < 86400) return `${Math.floor(ageSeconds / 3600)} sa`;
  return `${Math.floor(ageSeconds / 86400)} gün`;
};
